export class SourcingNeedModel {
    id: number
    created_by: number
    modified_by: number
    created_at: string
    modified_at: string
    event_details: any
    event: number
    is_av_required: boolean
    is_furniture_required: boolean
    furniture_details: string
    is_speaker_on_stage_talent: boolean
    is_transport_required: boolean
    is_gift_required: boolean
    gift_details: string
    gift_rate: number
    is_stage_required: boolean
    is_registration_desk_required: boolean
    is_photographer_required: boolean
    is_videographer_required: boolean
    is_experience_required: boolean
    is_production_fabrication_required: boolean
    event_type: number
    venue_details: any
    catering: number
    experience_type: number[]
    speaker_on_stage_talent: number[]
    production_and_fabrication_details: any
}